import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlayBare = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	stroke: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.33333 3.33333C3.33326 3.09873 3.3951 2.86826 3.51259 2.66519C3.63008 2.46213 3.79907 2.29366 4.0025 2.1768C4.20593 2.05993 4.43659 1.99882 4.67119 1.99961C4.9058 2.00041 5.13604 2.06309 5.33867 2.18133L13.3367 6.84667C13.5385 6.96379 13.7061 7.13183 13.8226 7.334C13.9392 7.53618 14.0006 7.7654 14.0008 7.99876C14.001 8.23212 13.94 8.46145 13.8238 8.66382C13.7076 8.8662 13.5403 9.03453 13.3387 9.152L5.33867 13.8187C5.13604 13.9369 4.9058 13.9996 4.67119 14.0004C4.43659 14.0012 4.20593 13.9401 4.0025 13.8232C3.79907 13.7063 3.63008 13.5379 3.51259 13.3348C3.3951 13.1317 3.33326 12.9013 3.33333 12.6667V3.33333Z",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgPlayBare;
